// Loader.jsx
import React from "react";

const Loader = ({ loading, children }) => {
    return (
        <div className="relative">
            {/* Content */}
            <div className={loading ? "opacity-40 pointer-events-none" : ""}>
                {children}
            </div>

            {/* Loader Overlay (only inside this div) */}
            {loading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white/60 rounded-lg">
                    <div className="w-8 h-8 border-4 border-gray-300 border-t-black rounded-full animate-spin"></div>
                </div>
            )}
        </div>
    );
};

export default Loader;
